import 'twin.macro';

import { Sparkles } from 'lucide-react';

import { IntervieweeInfoType } from '@/utils/convertIntervieweeInfo';

const ProfileHighlightCount = ({ highlightCount }: Pick<IntervieweeInfoType, 'highlightCount'>) => {
  return (
    <div tw="py-2 px-3 bg-[hsla(51, 100%, 50%, 1)] rounded-[100px] flex-row flex items-center justify-center gap-2 w-full h-[32px]">
      <Sparkles color="black" fill="black" size="16px" />
      <p tw="text-sm pt-1 font-medium flex flex-row gap-1">
        <span>{highlightCount}</span>
        <span>Highlights</span>
      </p>
    </div>
  );
};

export default ProfileHighlightCount;
